module.exports = __webpack_public_path__ + "static/media/yahooIcon.bae726dd.svg";